






































































































import { Component, Emit, Prop, Vue } from "vue-property-decorator";
import { Factor } from "@/api/model/FactorResource";
import { Choice } from "@/api/model/Choice";
import DescriptionEditor from "@/components/common/DescriptionEditor.vue";
import FileSelector from "@/components/common/FileSelector.vue";
import ChoiceFactorInputDateTime from "@/components/choice-input/ChoiceFactorInputDateTime.vue";
import moment from "moment";
import { v4 as uuidv4 } from "uuid";

@Component({
    components: {ChoiceFactorInputDateTime, FileSelector, DescriptionEditor}
})
export default class QuestionnaireFactorValueInput extends Vue {

    @Prop()
    factor!: Factor;

    @Prop()
    choice!: Choice;

    @Emit('value-chosen')
    private saveValue(factor: Factor, value: any) {
        this.choice[factor.dataField || ''] = value;
    }

    private datepickerMenu = false;

    get keyPrefix() {
        let prefix = ''
        if (this.choice.id) {
            prefix = prefix + this.choice.id + "/"
        } else {
            prefix = uuidv4() + "/"
        }
        // if (this.listIndex == null) {
        return prefix + this.factor.dataField;
        // }
        // return prefix + this.dataField + '-' + this.listIndex;
    }

    get dateFormValue() {
        if (this.factor.valueTypeDefinition && this.factor.valueTypeDefinition.valueType === 'DATE_TIME') {
            if (this.choice[this.factor.dataField || '']) {
                return moment(this.choice[this.factor.dataField || '']).format(this.factor.valueTypeDefinition.format)
            }
        }
    }

}
